import { render, staticRenderFns } from "./CustomerTrainingItemNotes.vue?vue&type=template&id=dd705d4c&"
import script from "./CustomerTrainingItemNotes.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports